import { CardMarketConditionCodeType } from "magic-shared-types";
import { StyledSelect } from "../common.style";
import { CARD_CONDITIONS_CARDMARKET } from "../../../constant";
import { Option } from "../../primitives";

interface ConditionDropdownCardMarketProps {
  condition: CardMarketConditionCodeType;
  setCondition: (arg1: CardMarketConditionCodeType) => void;
}

export const ConditionDropdownCardMarket = ({
  condition,
  setCondition,
}: ConditionDropdownCardMarketProps) => {
  return (
    <StyledSelect
      value={condition}
      onChange={(e) =>
        setCondition(e.target.value as CardMarketConditionCodeType)
      }
    >
      {CARD_CONDITIONS_CARDMARKET?.map((condition) => (
        <Option value={condition.code}>
          {condition.value} {`(${condition.code})`}
        </Option>
      ))}
    </StyledSelect>
  );
};
